var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressive",on:{"click":_vm.open}},[(_vm.paths.smallImage)?_c('img',{staticClass:"img placeholder",attrs:{"src":_vm.paths.smallImage},on:{"load":_vm.placeholderEnd}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }